import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { fetchSuperAgentOnlineBalanceLedger } from '../services/api';

export type UseSuperAgentOnlineBalanceLedgerParams = {
  currency?: string;
  type?: string;
  limit?: number;
  offset?: number;
  sort?: string;
  sort_dir?: 'asc' | 'desc';
};

export function useSuperAgentOnlineBalanceLedger(params: UseSuperAgentOnlineBalanceLedgerParams = {}) {
  const { currency = 'USD', type, limit = 200, offset = 0, sort, sort_dir } = params;
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchSuperAgentOnlineBalanceLedger({
        currency,
        type,
        limit,
        offset,
        sort,
        sort_dir,
      });
      if (res.success && res.data) setData(res.data);
      else setData(null);
    } catch {
      toast.error('Could not load USD wallet transactions');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [currency, type, limit, offset, sort, sort_dir]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, reload: load };
}

